import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Form, ResetOnSuccess, Field, setErrors, FormError } from '../form';
import ActivateModalTrigger from '../billing/ActivateModalTrigger';
import AccountLimitsError from '../billing/AccountLimitsError';

import {
  FormGroup,
  Button,
  Row,
  Col,
  ModalBody,
  ModalFooter
} from 'reactstrap';


import PreloadUniqueSlug from './PreloadUniqueSlug';
import CustomSlugInputField from './CustomSlugInputField';
// import ModalLink from '../modals/ModalLink';

import { urlScraperDecorator, UrlPreview } from './urlScraper';
import setFieldData from 'final-form-set-field-data';
import copyToClipboard from '../../utils/copyToClipboard';

import ProjectSelect from '../Projects/ProjectSelect';




const mapStateToProps = state => ({ });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch)
};

class CloneLinkForm extends Component {
  
  constructor (props) {
    super(props);
    
    this.copyOnSubmit = this.copyOnSubmit.bind(this)
    this.toggleCopy = this.toggleCopy.bind(this);
    this.urlScraperDecorator = urlScraperDecorator('url', 'meta');
    
    this.state = {
      copy: true
    };
  }
  
  toggleCopy () {
    this.setState({ copy: !this.state.copy })
  }
  
  copyOnSubmit (values){
    if (this.state.copy === false || !(values.slug || values.unique_slug))
      return 
    const shortUrl = "https://shor.by/" + (values.slug || values.unique_slug)
    copyToClipboard(shortUrl)
    // console.log("copy link", "https://shor.by/" + (values.slug || values.unique_slug));
  }
  
  render () {
    const { onSubmit, onSuccess, onFail, resetOnSuccess, catchSubmitEvent, modalWrappers, initialValues} = this.props;
    
    const BodyWrapper = modalWrappers === true ? ModalBody : React.Fragment
    const FooterWrapper = modalWrappers === true ? ModalFooter : React.Fragment
    
    return (
      <Form
        {...{onSubmit, onSuccess, onFail, resetOnSuccess, initialValues}}
        decorators={[ this.urlScraperDecorator ]}
        mutators={{setFieldData, setErrors}}
        render={({ submitError, handleSubmit, submitting, pristine, values, form: {reset} }) => (
          
          <form className="link-form" onSubmit={(event) => {catchSubmitEvent && catchSubmitEvent(event); this.copyOnSubmit(values); handleSubmit(event);} } noValidate={true}>
            
            <BodyWrapper>
              {submitError && <FormError>{submitError}</FormError>}
              <ActivateModalTrigger />
              <AccountLimitsError />
              
              <FormGroup>
                <UrlPreview name="meta" />
              </FormGroup>
              
              <Row>
                <Col sm={12} className="form-group">
                  <PreloadUniqueSlug />
                  <label>New link address:</label>
                  <CustomSlugInputField submitting={submitting} values={values} />
                </Col>
              </Row>
              
              <FormGroup className="mt-2">
                <label>Save to project:</label>  
                <Field 
                  name="project_id"
                  component={ProjectSelect}
                />
              </FormGroup>
              
              <ResetOnSuccess enabled={resetOnSuccess || false} reset={reset} />
            </BodyWrapper>
              
            {false && <pre>{JSON.stringify(values, 0, 2)}</pre>}
            <FooterWrapper>
              {(values.unique_slug || values.slug) && (
                <label className="small">copy to clipboard  
                  <input type="checkbox" checked={this.state.copy} onChange={this.toggleCopy} />
                </label>)}
              
              <div className="text-right">
                <Button
                  color="primary"
                  type="submit"
                  className="btn-wide upcase"
                  disabled={submitting}
                  onSubmit={this.copyOnSubmit}>
                  Duplicate
                </Button>
              </div>
            </FooterWrapper>
            
          </form>
        )}
      />
    )
  };
}

export default connect(mapStateToProps, matchDispatchToProps)(CloneLinkForm);


// WEBPACK FOOTER //
// ./src/components/Links/cloneForm.js